module.exports = __webpack_public_path__ + "static/sommer-02-e4dd59e14f7440ee8823a369322592e5.jpg";